import {IDownloadNetworkPrefixListFileIntAction} from '../actions/export-network-prefix-list-int'
import {IServicePerformanceState} from '../state'

export type IDownloadNetworkPrefixListIntAction = IDownloadNetworkPrefixListFileIntAction

export const exportNetworkPrefixListIntReducer = (
  state: IServicePerformanceState,
  action: IDownloadNetworkPrefixListIntAction,
) => {
  return {
    ...state,
    exportNetworkPrefixListIntStatus: {
      ...state.exportNetworkPrefixListIntStatus,
      status: action.status,
    },
  }
}
